import BreadcrumbBar from '@interflora/ui-components/build/components/BreadcrumbBar/BreadcrumbBar'
import MainContent from '@interflora/ui-components/build/components/MainContent/MainContent'
import PrivacySettings from 'components/PrivacySettings'
import React from 'react'
import { getOutlineRenderGraph } from 'utils/getRenderGraph'
import Page from '../components/Page/Page'
import { renderComponents } from '../utils/components'

const Index = (renderGraph: any) => {
  const { page } = renderGraph
  return (
    <Page renderGraph={renderGraph}>
      <>
        {renderComponents(page.components.header)}
        <BreadcrumbBar
          links={[
            { label: 'Home', url: '/' },
            { label: 'Help', url: '/faq' },
            { label: 'Preferences', url: '/preferences' },
          ]}
        />
        <MainContent>
          <PrivacySettings />
        </MainContent>
        {renderComponents(page.components.footer)}
      </>
    </Page>
  )
}

export default Index

export const getStaticProps = (ctx) =>
  getOutlineRenderGraph(ctx, 'DEFAULT', 'preferences', { title: 'Privacy Settings', noIndex: true })
